export default {
  Individual: 'individuallyAssigned',
  ProfileBased: 'profileBased',
}
